import { c as _c } from "react/compiler-runtime";
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { useConfigsContext } from '@/context/ConfigsContext';
import { getCardType } from '@/lib/viverse-world-card';
import { Room } from '@/services/cms';
type UserPublicPersonaRoomsProps = {
  publicRooms: Room[];
};
function UserPublicPersonaRooms(t0) {
  const $ = _c(7);
  const {
    publicRooms
  } = t0;
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  let t1;
  if ($[0] !== htcToken || $[1] !== publicRooms) {
    let t2;
    if ($[3] !== htcToken) {
      t2 = (room, index) => <ViverseWorldCard className="profile-card-size" key={`world-card-${room.id}-${index}`} info={room} hideLiked={!htcToken} hidePremiumBadge={false} cardType={room.content_type ? getCardType(room.content_type) : "experiences"} />;
      $[3] = htcToken;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = publicRooms.map(t2);
    $[0] = htcToken;
    $[1] = publicRooms;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="no-scrollbar w-full max-lg:overflow-scroll max-lg:scroll-smooth md:-mx-2"><div className="flex gap-2 md:gap-1 lg:flex-wrap lg:gap-2">{t1}</div></div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default UserPublicPersonaRooms;